import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "invalid-feedback" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "flex mt-auto" }

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import Textarea from 'primevue/textarea'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'
import vSelect from 'vue-select'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, getCurrentInstance, ref, computed } from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull } from 'lodash'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'

const moduleStore = 'hjpTable'
const endpoint = '/talent/v1/requirements'

export default /*@__PURE__*/_defineComponent({
  __name: 'RequirementForm',
  setup(__props) {

const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataForm = ref()
const idPrams = computed(() => store.state[moduleStore].modal?.data?.id)

const defineParameterInput = (data: any) => {
  if (data === 'Integer') {
    return { label: 'Angka', value: 'Integer' }
  }
  return { label: 'Huruf', value: 'String' }
}

const initialValues = {
  Name: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.name : '',
  Description: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.description : '',
  DataType: store.state.hjpTable.modal.data ? defineParameterInput(store.state.hjpTable.modal.data.dataType) : null,
}

const label = ref({
  positionName: 'Nama Persyaratan Divisi',
  deposit: {
    title: 'Deposit',
    placeholder: 'Masukkan nilai deposit (jika ada)'
  },
  level: {
    title: 'Level',
    placeholder: 'Contoh: 1, 2, 3, dan seterusnya'
  },
  document: {
    title: 'Dokumen yang Dibutuhkan',
    type: 'Tipe Dokumen',
    status: 'Status'
  }
})

const dataTypeOptions = ref([
  { label: 'Angka', value: 'Integer' },
  { label: 'Huruf', value: 'String' },
])

const schema = Yup.object().shape({
  Name: Yup.string()
    .required('Nama Persyaratan Divisi harus diisi')
    .max(50, 'Nama Persyaratan Divisi tidak boleh melebihi 50 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Divisi tidak boleh hanya menggunakan spasi')
    .test('unique-name', 'Nama Persyaratan Divisi sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['name']
        })}`)
        const filterResult = res.result.data.filter((x: any) => x.name.toLowerCase() === val.toLowerCase())
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  DataType: Yup.object().required('Parameter harus dipilih'),
  // Description: Yup.string().required('Keterangan harus diisi'),
})

const onSubmit = (values: any) => {
  console.log('masukk submit', values)
  // eslint-disable-next-line no-use-before-define
  processSubmit(values)
}

const hideSidebar = () => {
  store.dispatch('setShowModal', false)
  store.dispatch('setTitleFormSidebar', null)
}

const changeOk = (val: any) => {
  console.log('valll', val)
}

const onSearchOption = (search: any, loading: any) => {
  console.log('search', search)
}

const onSelectedBank = (selected: any) => {
  console.log('selected', selected)
}

const processSubmit = async (val: any) => {
  store.dispatch('showLoading')
  console.log('val', val)

  if (isNull(store.state.hjpTable.modal.data)) {
    dataForm.value = {
      name: val.Name,
      dataType: val.DataType.value,
      description: val.Description,
      // IsActive: val.IsActive
    }
    console.log('dataForm', dataForm.value)
  } else {
    dataForm.value = {
      id: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.id : '',
      name: val.Name,
      dataType: val.DataType.value,
      description: val.Description,
      // IsActive: val.IsActive,
    }
  }
  const response = isNull(store.state.hjpTable.modal.data) ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, store.state.hjpTable.modal.data.id, dataForm.value)
  console.log('response', response)
  if (!response.error) {
    $toast.add({
      severity: 'success',
      summary: isNull(store.state.hjpTable.modal.data) ? 'Jenis persyaratan berhasil ditambahkan!' : 'Jenis persyaratan berhasil diubah!',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data jenis persyaratan telah berhasil ditambahkan ke dalam sistem' : 'Data jenis persyaratan di sistem telah berhasil diperbaruhi',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    $toast.add({
      severity: 'error',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data Gagal Ditambahkan' : 'Data Gagal Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('setShowModal', false)
  store.dispatch('setReloadDataTable', true)
  store.dispatch('setTitleFormSidebar', null)
  store.dispatch('hideLoading')
}

onMounted(() => {
  console.log('store', store.state)
  let titleForm = 'Tambah'
  if (store.state.hjpTable.modal.data) {
    titleForm = 'Edit'
  }
  store.dispatch('setTitleFormSidebar', `${titleForm} Jenis Persyaratan`)
  store.dispatch('setToggleDatatableSidebarDeleteButton', false)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values, meta }) => [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("label", {
            for: "name",
            class: "label-text required"
          }, "Nama Persyaratan", -1)),
          _createVNode(_unref(Field), { name: "Name" }, {
            default: _withCtx(({ handleChange, handleBlur, field }) => [
              _createVNode(_unref(InputText), _mergeProps({
                id: "name",
                "aria-describedby": "name-help",
                placeholder: "Contoh: Umur Minimal",
                class: `input-primary ${errors.Name ? 'input-invalid' : ''}`
              }, field, {
                onChange: handleChange,
                onBlur: handleBlur,
                minlength: 50,
                maxlength: 50
              }), null, 16, ["class", "onChange", "onBlur"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_2, _toDisplayString(errors.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("label", {
              for: "dataType",
              class: "label-text required"
            }, "Parameter", -1)),
            _createVNode(_unref(Field), {
              id: "dataType",
              name: "DataType",
              class: _normalizeClass(`input-primary ${errors.DataType ? 'input-invalid' : ''}`),
              validateOnInput: true
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Dropdown), {
                  modelValue: values.DataType,
                  "onUpdate:modelValue": [($event: any) => ((values.DataType) = $event), (val) => setFieldValue('DataType', val)],
                  options: dataTypeOptions.value,
                  optionLabel: "label",
                  placeholder: "Pilih Parameter",
                  class: "w-full md:w-14rem"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(errors.DataType), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("label", {
            for: "description",
            class: "label-text"
          }, "Keterangan", -1)),
          _createVNode(_unref(Field), { name: "Description" }, {
            default: _withCtx(({ handleChange, handleBlur, field }) => [
              _createVNode(_unref(Textarea), _mergeProps({
                maxlength: 400,
                id: "description",
                "aria-describedby": "description-help",
                autoResize: true,
                rows: "3"
              }, field, {
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                onChange: handleChange,
                onBlur: handleBlur
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, _toDisplayString(errors.Description), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Kembali")
            ])),
            _: 1,
            __: [4]
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Simpan")
            ])),
            _: 1,
            __: [5]
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})